<template>
  <div class="financial-health">
    <InfoBox v-translate class="info-box" :content="content" />
    <div v-if="!loading" style="margin-top: 1rem; margin-bottom: 1rem">
      <p style="font-size: 0.9rem" v-translate>
        The following data is requested to help the Grant Circle understand how it can better help
        participants, and will not impact grant decisions in any way.
      </p>
    </div>
    <LoadSpinner v-if="loading" />
    <div v-else class="survey-container">
      <h4 class="header">{{ displayName }}</h4>
      <SurveyResponseComponent @survey-done="onSurveyDone" :surveyResponse="surveyResponse" />
    </div>
  </div>
</template>

<script>
import SurveyResponse from '@/services/surveyresponses'
import SurveyResponseComponent from '@/components/SurveyResponse'
import { mapState } from 'vuex'
import LoadSpinner from '@/components/LoadSpinner'
import InfoBox from '@/components/InfoBox'

export default {
  name: 'FinancialHealthOnboarding',
  components: {
    SurveyResponseComponent,
    LoadSpinner,
    InfoBox,
  },
  data() {
    return {
      loading: null,
      surveyResponse: null,
      surveyName: 'Financial Health',
    }
  },
  async created() {
    this.loading = true
    const isComplete = await SurveyResponse.checkIfEmployeeHasCompleted(this.user, this.surveyName)
    // If user has already completed this survey, route to next page
    if (isComplete) {
      this.$router.push({ name: 'PayPalVerify' })
      // Otherwise, pull in a survey for them to complete
    } else {
      const surveyResponse = await SurveyResponse.getOrCreate(this.user, this.surveyName)
      this.surveyResponse = surveyResponse
    }
    this.loading = false
  },
  methods: {
    onSurveyDone(success) {
      if (success) {
        this.$router.push({ name: 'PayPalVerify' })
      } else {
        this.$Alert.alert({
          type: 'error',
          message: `<h4>Something went wrong!</h4><p>Please try again later.</p>`,
          timeout: 6000,
        })
      }
    },
  },
  computed: {
    ...mapState(['user']),
    content() {
      return this.$gettext(
        'To make a grant request, please complete your Grant Circle profile by answering the questions below.',
      )
    },
    displayName() {
      return this.$gettext('Financial Health')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';

.financial-health {
  @include screen-container();
  justify-content: flex-start;
}
.survey-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header {
  font-weight: 600;
  margin: 1rem 0 2rem 0;
}
.skip {
  font-size: 1.2rem;
  font-family: 'Poppins-Medium';
  color: var(--dark-brand-color);
}
</style>
